import React from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonPrimary } from '../../../../utils/Button';
import { EditIcon, TickIcon } from '../../../../utils/SVGIcon';

function TextPreview(rawText = '') {
    const splitText = rawText?.split('\n');
    return (
        <>
            {splitText.map((text, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <p key={index}>{text}</p>
            ))}
        </>
    );
}

function ItemCard({ item, setOpenModal, handleReload }) {
    const { setConfirm, setTemplateLoading, setMessage } = useTemplate();
    const { put } = useApi();
    const handleSubmit = () => {
        put(`api/setting/invoice-config/payment-info-add`, {
            ActionType: 'default',
            PaymentItemId: item.id,
            PaymentInfo: item?.text
        })
            .then(({ error, message }) => {
                if (error) {
                    throw new Error(message);
                }
                handleReload();
                setMessage({ text: 'Payment info set as default', type: 'success' });
                setConfirm(null);
                setTemplateLoading(false);
            })
            .catch((err) => {
                setMessage({ text: err.message, type: 'error' });
            })
            .finally(() => {
                setTemplateLoading(false);
            });
    };

    const handleMakeDefault = () => {
        setConfirm({
            text: 'Are you sure you want to make this payment info default?',
            textAction: 'Make Default',
            clickAction: () => {
                setTemplateLoading(true);
                handleSubmit();
            }
        });
    };
    return (
        <div className="text-sm bg-primary-50 p-3 rounded-10 relative">
            {item?.isDefault && (
                <span className="absolute top-10 right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
                    Default
                </span>
            )}
            {/* Edit button */}
            <button
                onClick={() => setOpenModal(`add_payment_info`, { item, isEdit: true })}
                type="button"
                className="absolute top-2 right-2 bg-primary-700 text-white px-1.5 py-1.5 rounded-full hover:bg-primary"
            >
                <EditIcon className="w-3 h-3" />
            </button>
            {!item?.isDefault ? (
                <button
                    onClick={handleMakeDefault}
                    type="button"
                    className="absolute top-2 right-9 bg-primary-700 text-white px-1.5 py-1.5 rounded-full hover:bg-primary"
                >
                    <TickIcon className="w-3 h-3" />
                </button>
            ) : null}
            {TextPreview(item.text)}
        </div>
    );
}

function InvoicePaymentConfig({ data, setOpenModal, handleReload }) {
    const infoDataArr = data || [];
    return (
        <div className="flex gap-2 flex-col border p-3 rounded-md ">
            <div className="flex justify-between">
                <div className="text-base font-medium text-primary">Payment Information:</div>
                <ButtonPrimary
                    title="Add Payment Info"
                    onClick={() => setOpenModal('add_payment_info')}
                />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 flex-1 ">
                {infoDataArr.length > 0 ? (
                    infoDataArr.map((info) => (
                        <ItemCard
                            key={info.id}
                            item={info}
                            setOpenModal={setOpenModal}
                            handleReload={handleReload}
                        />
                    ))
                ) : (
                    <div className="text-sm text-gray-500">No payment information available</div>
                )}
            </div>
        </div>
    );
}

export default InvoicePaymentConfig;
